import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "./layout/AppShell.tsx";
import { CatalogPage } from "./pages/CatalogPage.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { OpeningPage } from "./pages/OpeningPage.tsx";
import { ProgressPage } from "./pages/ProgressPage.tsx";
import { TrainerPage } from "./trainer/TrainerPage.tsx";

/** A fresh trainer page per course, so one course's retries never carry over. */
function TrainerRoute() {
  const { courseId = "" } = useParams();
  return <TrainerPage key={courseId} />;
}

export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/openings" element={<CatalogPage />} />
        <Route path="/opening/:slug" element={<OpeningPage />} />
        <Route path="/train/:courseId" element={<TrainerRoute />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
